import React from 'react';

import useHasPermission from './useHasPermission';

export default function HasPermission({ children, permission, module, subject }) {
	const hasPermission = useHasPermission({ permission, module, subject });
	return children(hasPermission);
}
